import React from "react";

const StatusTooltip = ({ statuses, currentStatusId }) => {
  if (!statuses || statuses.length === 0) return null;

  const renderStatusNode = (status, depth = 0) => {
    const isCurrent = String(status.id) === String(currentStatusId);
    return (
      <div key={status.id} style={{ paddingLeft: depth * 16 }}>
        <div
          className={`flex items-center gap-1.5 py-0.5 ${
            isCurrent ? "font-semibold text-white" : "text-gray-300"
          }`}
        >
          <span
            className={`inline-block w-1.5 h-1.5 rounded-full flex-shrink-0 ${
              isCurrent ? "bg-blue-400" : "bg-gray-500"
            }`}
          />
          <span className="text-xs whitespace-nowrap">{status.name}</span>
        </div>
        {status.children?.length > 0 &&
          status.children.map(child => renderStatusNode(child, depth + 1))}
      </div>
    );
  };

  return (
    <div className="py-1" data-testid="status-tooltip">
      <p className="text-xs font-semibold text-gray-300 mb-1.5">All Statuses</p>
      {statuses.map(status => renderStatusNode(status))}
    </div>
  );
};

export default StatusTooltip;
